import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { postDataAPI } from "../utils/fetchData";

const Talktous = () => {
	const dispatch = useDispatch();
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		mobile: "",
		message: "",
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
			...prevState, 
			[name]: value,
		}));
	};

	const handlePhoneChange = (value) => {
		setFormData({ ...formData, mobile: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI("createcontactus", formData);
			if (res.status === 200) {
				alert("Thank you for your interest. We will get back to you soon");
				window.location.reload();
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}
	};

	const [errors, setErrors] = useState({});

	const validateForm = () => {
		const newErrors = {};
		if (!formData.name) {
			newErrors.name = "Name is required.";
		}

		if (!formData.email) {
			newErrors.email = "Email is required.";
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.emailInvalid = "Email is invalid.";
		}

		if (!formData.mobile) {
			newErrors.mobile = "Mobile number is required.";
		}

		if (!formData.message) newErrors.message = "Message is required.";
		else if (formData.message < 10)
			newErrors.messageLength = "Message should contain atleast 10 characters";

		setErrors(newErrors);
		// console.log("newErrors", newErrors);
		return Object.keys(newErrors).length === 0;
	};

	return (
		<>
			<div
				style={{
					backgroundColor: "#006436",
					backgroundImage: 'url("/images/bg-shap.png")',
					backgroundRepeat: "no-repeat",
					backgroundSize: "contain",
					backgroundPosition: "right center",
					backgroundSize: "65% 100%",
					backgroundPositionX: "100%",
					backgroundPositionY: "50%",
				}}>
				<div className="container">
					<div
						className="row"
						style={{
							padding: "100px 0px",
							backgroundImage: 'url("/images/bg-shap.png")',
						}}>
						<div className="col-lg-6 tts-left">
							<img alt="talktous" src="../images/talktous.jpg" />
							<div className="tts-left-overlap">
								<div style={{ display: "flex", flexDirection: "row" }}>
									<div style={{ padding: "15px 15px 0px 0px" }}>
										<i
											className="fa fa-phone"
											style={{ fontSize: "50px", color: "#006436" }}
											aria-hidden="true"></i>
									</div>
									<div>
										<h4 className="tts-left-text1">Need help?</h4>
										<h3 className="tts-left-text2">+91 98480 34740</h3>
									</div>
								</div>
							</div>
						</div>
						<div
							className="col-lg-6"
							style={{
								padding: "0px 15px",
							}}>
							<h6
								style={{
									color: "rgb(255, 255, 255)",
									display: "block",
									fontFamily: "Rajdhani, sans-serif",
									fontSize: "18px",
									fontWeight: 700,
									letterSpacing: "4px",
									lineHeight: "28px",
									marginTop: "30px",
								}}>
								TALK TO US
							</h6>
							<h2 className="tts-right-text2">
								Accelerating Growth And Success
							</h2>
							<form onSubmit={handleSubmit}>
								<input
									type="text"
									name="name"
									value={formData.name}
									onChange={handleInputChange}
									placeholder="Name"
									style={{
										width: "100%",
										backgroundColor: "#15222C",
										padding: "0px 10px",
										height: "65px",
										color: "#ffffff",
										fontFamily: "Rubik, sans-serif",
										fontSize: "16px",
										fontWeight: 400,
										height: "65px",
										letterSpacing: "1.4px",
										lineHeight: "25.6px",
										borderRadius: "5px",
										// marginBottom: "20px",
										border: "none",
									}}
								/>
								<p
									style={{
										visibility: errors.name ? "visible" : "hidden",
									}}
									className="error-message">
									Name is required.
								</p>
								<div
									className="tts-left-input-flex"
									style={{ marginBottom: "0px" }}>
									<div style={{ width: "100%" }}>
										<input
											type="email"
											placeholder="E-mail"
											name="email"
											value={formData.email}
											onChange={handleInputChange}
											style={{
												width: "100%",
												backgroundColor: "#15222C",
												padding: "0px 10px",
												height: "65px",
												color: "#ffffff",
												fontFamily: "Rubik, sans-serif",
												fontSize: "16px",
												fontWeight: 400,
												height: "65px",
												letterSpacing: "1.4px",
												lineHeight: "25.6px",
												borderRadius: "5px",
												border: "none",
											}}
										/>
										<p
											className="error-message"
											style={{
												visibility:
													errors.email || errors.emailInvalid
														? "visible"
														: "hidden",
											}}>
											{errors.email ? errors.email : errors.emailInvalid}
											{!errors.email && !errors.emailInvalid && "Text"}
										</p>
									</div>
									<div style={{ width: "100%" }}>
										<PhoneInput
											country={"in"}
											type="tel"
											name="mobile"
											value={formData.mobile}
											onChange={handlePhoneChange}
											placeholder="Number"
											inputStyle={{
												border: "none",
												boxShadow: "none",
												width: "100%",
												backgroundColor: "#15222C",
												padding: "0px 10px",
												height: "65px",
												color: "#ffffff",
												fontFamily: "Rubik, sans-serif",
												fontSize: "16px",
												fontWeight: 400,
												height: "65px",
												letterSpacing: "1.4px",
												lineHeight: "25.6px",
												borderRadius: "5px",
												border: "none",
											}}
										/>
										<p
											style={{
												visibility: errors.mobile ? "visible" : "hidden",
											}}
											className="error-message">
											Mobile is required.
										</p>
									</div>
								</div>
								<textarea
									placeholder="Type Here"
									name="message"
									value={formData.text}
									onChange={handleInputChange}
									style={{
										width: "100%",
										backgroundColor: "#15222C",
										padding: "10px 10px 0 10px",
										minHeight: "65px",
										color: "#ffffff",
										fontFamily: "Rubik, sans-serif",
										fontSize: "16px",
										fontWeight: 400,
										height: "65px",
										letterSpacing: "1.4px",
										lineHeight: "25.6px",
										borderRadius: "5px",
										height: "130px",
										border: "none",
									}}
								/>
								<p
									className="error-message"
									style={{
										visibility:
											errors.message || errors.messageLength
												? "visible"
												: "hidden",
									}}>
									{errors.message ? errors.message : errors.messageLength}
									{!errors.message && !errors.messageLength && "Text"}
								</p>
								<button
									style={{
										backgroundColor: "#2F815B",
										color: "rgb(255, 255, 255)",
										cursor: "pointer",
										boxShadow: "none",
										border: "none",
										fontFamily: "Rubik, sans-serif",
										fontSize: "16px",
										borderRadius: "5px",
										fontWeight: 700,
										height: "64.7831px",
										letterSpacing: "1.28px",
										lineHeight: "18.4px",
										width: "100%",
									}}>
									SUBMIT HERE
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Talktous;
